import { Grid3X3, LineChart, ListIcon } from 'lucide-react';

import TabRadio from '@/components/TabRadio/TabRadio';
import AMP_KEYS from '@/configs/amp-track-keys';
import { useSignalsSearchParams } from '@/pages/workspace/signals/search-params-schema';
import { track } from '@/utils/track/track';

import { SIGNAL_PAGE_VIEW_TYPE } from '../../model';

export default function ViewControlHeaderTabs() {
  const [params, setParams] = useSignalsSearchParams();

  const handleViewTypeChange = (newViewType: SIGNAL_PAGE_VIEW_TYPE) => {
    track(AMP_KEYS.SIGNAL_VIEW_TYPE_CHANGE, { view_type: newViewType });
    setParams({ view: newViewType as any });
  };

  return (
    <TabRadio
      options={[
        {
          node: (
            <div className="flex items-center justify-center gap-2">
              <ListIcon className="size-4" />
              List
            </div>
          ),
          key: SIGNAL_PAGE_VIEW_TYPE.LIST,
        },
        {
          node: (
            <div className="flex items-center justify-center gap-2">
              <LineChart className="size-4" />
              Trends
            </div>
          ),
          key: SIGNAL_PAGE_VIEW_TYPE.CHART,
        },
        {
          node: (
            <div className="flex items-center justify-center gap-2">
              <Grid3X3 className="size-4" />
              Matrix
            </div>
          ),
          key: SIGNAL_PAGE_VIEW_TYPE.MATRIX,
        },
      ]}
      value={params.view as SIGNAL_PAGE_VIEW_TYPE}
      onChange={handleViewTypeChange}
    />
  );
}
